import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-receipt-code',
    imports: [MatDialogModule],
    templateUrl: './receipt-code.component.html',
    styleUrl: './receipt-code.component.scss'
})
export class ReceiptCodeComponent {
  showCode = false;
  constructor(
    public dialogRef: MatDialogRef<ReceiptCodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { code: string; }
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
